import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { OfferService } from '../../../_services/offer.service';
import { PlaceService } from '../../../_services/place.service';
declare var jQuery: any;
import '../../../../assets/semantic/semantic.min.js';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DateService } from '../../../_services/date.service';
import { IMyDpOptions } from 'mydatepicker';

@Component({
  selector: 'app-edit-offer',
  templateUrl: './edit-offer.component.html',
  styleUrls: ['./edit-offer.component.css']
})
export class EditOfferComponent implements OnInit {
  @Output() refresh: EventEmitter<boolean> = new EventEmitter<boolean>();
  private updating_offer: boolean;
  private offer_id: number;

  public myDatePickerOptions: IMyDpOptions = {
    // other options...
    dateFormat: 'dd/mm/yyyy',
    openSelectorOnInputClick: true,
    editableDateField: false
  };

  constructor(private service: OfferService, private place_service: PlaceService, private date_service: DateService) { }

  edit_offer = new FormGroup({
    seller: new FormControl('', [Validators.required]),
    departure_id: new FormControl('', [Validators.required]),
    arrival_id: new FormControl('', [Validators.required]),
    vehicle: new FormControl('', [Validators.required]),
    quantity: new FormControl('', [Validators.required]),
    departure_date: new FormControl(''),
    arrival_date: new FormControl(''),
    buy_price: new FormControl(''),
    sell_price: new FormControl(''),
    note: new FormControl()
  });

  ngOnInit() {
  }

  openModal(offer) {
    this.offer_id = offer.id;

    this.edit_offer.patchValue(offer);

    if (offer.departure_date) {
      this.edit_offer.patchValue({
        departure_date: {
          formatted: this.date_service.myDateFormatted(offer.departure_date)
        }
      })
    }

    if (offer.arrival_date) {
      this.edit_offer.patchValue({
        arrival_date: {
          formatted: this.date_service.myDateFormatted(offer.arrival_date)
        }
      })
    }

    jQuery('#edit-offer-modal').modal({ inverted: true }).modal('show');

  }

  submitOfferForm() {
    this.edit_offer.disable();
    this.updating_offer = true; // Disable the loading button apparition
    if (this.edit_offer.value.seller instanceof Object) this.edit_offer.patchValue({ seller: this.edit_offer.value.seller.id }); // Avoid seller being an object
    if (this.edit_offer.value.departure_id instanceof Object) this.edit_offer.patchValue({ departure_id: this.edit_offer.value.departure_id.id }); // Avoid seller being an object
    if (this.edit_offer.value.arrival_id instanceof Object) this.edit_offer.patchValue({ arrival_id: this.edit_offer.value.arrival_id.id }); // Avoid seller being an object
    // Set Dates values correctly
    if (this.edit_offer.value.departure_date && this.edit_offer.value.departure_date.formatted) this.edit_offer.patchValue({ departure_date: this.edit_offer.value.departure_date.formatted });
    if (this.edit_offer.value.arrival_date && this.edit_offer.value.arrival_date.formatted) this.edit_offer.patchValue({ arrival_date: this.edit_offer.value.arrival_date.formatted });
    //console.log(this.edit_offer.value);
    this.service.updateOffer(this.offer_id, this.edit_offer.value)
      .subscribe(response => {
        this.updating_offer = false; // Disable the loading button apparition
        this.edit_offer.enable(); // Re Enable the Form
        this.edit_offer.reset(); // Reset It
        this.offer_id = undefined;
        this.refresh.emit(true); // Emmit the refresh Event
        jQuery('#edit-offer-modal').modal({ closable: true }).modal('hide'); // Set the modal closable & Close the modal
      });
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_components/offer/edit-offer/edit-offer.component.ts